import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AssetsModule } from './assets/assets.module';
import { EditorialToolsModule } from './editorialtools/editorialtools.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/components/dashboard.component';
import { DashboardService } from './dashboard/services/dashboard.service';
import { httpInterceptorProviders } from './authentication/interceptors';
import { AuthenticationModule } from './authentication/authentication.module';
import { UrlHelperService } from './shared/services/urlHelperService';
import { UrlService } from './shared/services/url.service';
import { AuthService } from './authentication/services/auth.service';
import { AuthGuard } from './authentication/services/auth.guard.service';
import { MatDialogModule, MatNativeDateModule, MatAutocompleteModule, MatTabsModule } from '@angular/material';
import { AlertService } from './shared/alert/services/alert.service';
import { AlertsComponent } from './shared/alert/components/scripts/alert.component';
import { LanguageModalComponent } from './shared/languageModal/components/scripts/languageModal.component';
import { CacheService } from './shared/services/cache.service';
import { UsersSiteModule } from './users/usersSite.module';
import { ExecuteService } from './shared/services/executeService.service';
import { ErrorHandlerService } from './shared/services/errorHandler.service';
import { BrokersModule } from './brokers/brokers.module';
import { SentimentModule } from './sentiment/sentiment.module';
import { PostTranslationsModule } from './postTranslations/postTranslations.module';
import { ConfigurationModule } from './configuration/configuration.module';
import { BOMaterialModule } from './material-module';
import { PaymentTransactionsModule } from './paymentTransactions/paymentTransactions.module';
import { StorageModule } from './storage/storage.module';
import { WebVitalsModule } from './webVitals/webVitals.module';
import { SideBarService } from './shared/services/sideBarService';
import { SideBarComponent } from './shared/components/sideBar/sideBar.component';
import { TradingStudioModule } from './tradingstudio/tradingstudio.module';

export function get_settings(appUrlService: UrlService) {
  return () => appUrlService.GetConfigurationData();
}

export function get_initial_settings(appUrlService: UrlService) {
  return () => appUrlService.GetInitialConfigurationData();
}

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    AlertsComponent,
    LanguageModalComponent,
    SideBarComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    BOMaterialModule,
    AssetsModule,
    EditorialToolsModule,
    AuthenticationModule,
    MatDialogModule,
    MatTabsModule,
    UsersSiteModule,
    SentimentModule,
    PostTranslationsModule,
    StorageModule,
    BrokersModule,
    ConfigurationModule,
    PaymentTransactionsModule,
    WebVitalsModule,
    TradingStudioModule
  ],
  providers: [
    SideBarService,
    DashboardService,
    httpInterceptorProviders,
    UrlHelperService, UrlService,
    AlertService,
    AuthService,
    AuthGuard,
    CacheService,
    ExecuteService,
    ErrorHandlerService,
    { provide: APP_INITIALIZER, useFactory: get_settings, deps: [UrlService], multi: true },
    { provide: APP_INITIALIZER, useFactory: get_initial_settings, deps: [UrlService], multi: true },
  ],
  bootstrap: [AppComponent],
  entryComponents: [LanguageModalComponent]
})



export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts